document.addEventListener('DOMContentLoaded', function () {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.js-fade:not(.fade-init)').forEach(function (el) {
    el.classList.add('fade-init');
    observer.observe(el);
  });
});
